import { CSSProperties } from 'react';

interface Props {
  viewBoxProp?: string;
  styleProp?: CSSProperties;
  color: string;
}

const LogoIcon = ({ viewBoxProp, styleProp, color }: Props) => {
  const viewBox = viewBoxProp ?? "0 0 35 35";
  const style = styleProp ?? { width: '100%', height: 'auto' };

  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox={viewBox} style={style}>
      <g id="Fandom_Logomark_1_">
        <g>
          <g>
            <path d="M19.73,35h-4.45c-1.38,0-2.69-0.54-3.67-1.52l-6.09-6.11C4.54,26.39,4,25.08,4,23.69V10.24
              C4,9.2,4.62,8.26,5.59,7.87c0.96-0.4,2.06-0.18,2.8,0.56L11,11.09V2.98C11,1.93,11.62,1,12.59,0.6c0.96-0.4,2.06-0.18,2.8,0.56
              l14.09,14.01c0,0,0,0,0.01,0.01c0.98,0.98,1.52,2.29,1.52,3.68v4.84c0,1.39-0.54,2.69-1.52,3.67l-6.08,6.11
              C22.43,34.44,21.09,35,19.73,35z M8,13.75v9.94c0,0.32,0.12,0.62,0.35,0.85l6.09,6.11c0.22,0.22,0.53,0.35,0.84,0.35h4.45
              c0.31,0,0.62-0.13,0.84-0.35l6.08-6.11c0.23-0.23,0.35-0.53,0.35-0.85v-4.84c0-0.32-0.12-0.62-0.35-0.85L15,6.41V16
              c0,0.81-0.49,1.54-1.25,1.85c-0.75,0.31-1.62,0.13-2.18-0.45L8,13.75z M12.56,3.99C12.57,3.99,12.57,3.99,12.56,3.99L12.56,3.99
              z"
              fill={color}
            />
          </g>
        </g>
      </g>
      <g>
        <path d="M17.55,25.92L17.55,25.92c-0.53,0-1.04-0.21-1.42-0.59l-1.55-1.55c-0.78-0.78-0.78-2.05,0.01-2.83
          c0.78-0.78,2.05-0.78,2.83,0.01l0.13,0.13l0.03-0.04c0.78-0.78,2.05-0.78,2.83,0c0.78,0.78,0.78,2.05,0,2.83l-1.45,1.46
          C18.59,25.71,18.08,25.92,17.55,25.92z"
          fill={color}
        />
      </g>
    </svg>
  );
}

export default LogoIcon;
